import { ApplicationDetail } from '../model/application/application-detail.model';

/**
 * Method returns true if application detail should be fetched from server.
 * Application should be fetched if it is present in list of expanded cards - as a result of TOGGLE_DETAIL action.
 *
 * List of (already) fetched details is checked if the detail has been loaded already.
 *
 * @param {string} appId
 * @param {string[]} expanded list of expanded application ids
 * @param {ApplicationDetail[]} details list of loaded application details
 * @return {boolean}
 */
export const shouldBeLoaded = (appId: string, expanded: string[], details: ApplicationDetail[]): boolean => {
    if (expanded.indexOf(appId) > -1) {
        const found = details.find(app => app.appId === appId);

        if (!found) { // not yet loaded then load
            return true;
        }
    }

    return false;
};

/**
 * Checks if passed application is expanded - detail is opened.
 * @param {string} appId id of the application
 * @param {string[]} expanded list of expanded application ids
 * @return {boolean} true if expanded false otherwise
 */
export const isExpandedApp = (appId: string, expanded: string[]): boolean => {
    return (expanded.indexOf(appId) > -1);
};

/**
 * Function returns application detail if passed appId is part of expanded array of strings / is expanded.
 *
 * On application expansion detail if fetched if not already in the store.
 *
 * @param {string} appId application id that is looked for
 * @param {string[]} expanded list of ids of expanded applications
 * @param {ApplicationDetail[]} details list of fetched application details
 * @return {ApplicationDetail} if application is expanded (is in expanded array) and detail has been already fetched
 * (is in details array)
 */
export const findExpandedApp = (appId: string, expanded: string[], details: ApplicationDetail[]): ApplicationDetail => {
    if (isExpandedApp(appId, expanded)) {
        return details.find(app => app.appId === appId);
    }
};





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/services/applications.helper.ts